import PropTypes from "prop-types";
import playButton from "styles/images/icons-video/Play.svg";
import pauseButton from "styles/images/icons-video/Pause.svg";
import { translate } from "constants";

export const PlayPause = ({ buttons, videoRef, locale, playingStatus }) => {
  const handlePlay = () => {
    videoRef.play();
  };
  const handlePause = () => {
    videoRef.pause();
  };
  return (
    <>
      {buttons.play_pause && playingStatus === "pause" && (
        <button
          data-testid={"play-web"}
          className={"btn_default hide_on_mobile"}
          onClick={handlePlay}
        >
          {translate("PLAY", locale)}
        </button>
      )}
      {buttons.play_pause && playingStatus === "play" && (
        <button
          data-testid={"pause-web"}
          className={"btn_default hide_on_mobile"}
          onClick={handlePause}
        >
          {translate("PAUSE", locale)}
        </button>
      )}
      {/*Mobile buttons*/}
      {buttons.play_pause && playingStatus === "pause" && (
        <button
          data-testid={"play-mobile"}
          className={"btn_default hide_on_web"}
          onClick={handlePlay}
        >
          <img src={playButton} alt={"play"} />
        </button>
      )}
      {buttons.play_pause && playingStatus === "play" && (
        <button
          data-testid={"pause-mobile"}
          className={"btn_default hide_on_web"}
          onClick={handlePause}
        >
          <img src={pauseButton} alt={"Pause"} />
        </button>
      )}
    </>
  );
};
PlayPause.propTypes = {
  buttons: PropTypes.shape({
    play_pause: PropTypes.bool.isRequired,
  }).isRequired,
  videoRef: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  playingStatus: PropTypes.string.isRequired,
};
